import cn from 'classnames';
import { BackgroundImage } from '@/shared/ui/layout';
import { HTMLAttributes, ReactNode } from 'react';
import styles from './app-shell.module.scss';


export function AppShell ({
    className,
    sidebar,
    header,
    children,
    twoColumns,
    narrow,
}: HTMLAttributes<HTMLDivElement> & {
    sidebar?: ReactNode;
    header?: ReactNode;
    twoColumns?: boolean;
    narrow?: boolean;
}) {
    return (
        <div
            className={ cn(styles.root, className) }
            data-template="app-shell"
        >
            <BackgroundImage/>

            <div className={ styles.inner }>
                { header ?? null }

                <div className={ styles.content }>
                    {
                        sidebar &&
                        <div className={ styles.sidebar }>
                            { sidebar }
                        </div>
                    }

                    <main
                        className={ cn(styles.main, {
                            [styles.two_columns]: twoColumns,
                            [styles.narrow]     : narrow,
                        }) }
                    >
                        { children }
                    </main>
                </div>
            </div>
        </div>
    );
}
